import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAllEvents, fetchAllEventsBeforeLogin, fetchAllEventTypes, fetchEventDetailsById, fetchEventDetailsByIdBeforLogin, fetchFancyData, fetchOpenBetEvents } from '../../../services/events';

export const fetchSportsEvents = createAsyncThunk(
    'sports/fetchEvents',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchAllEvents();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch sports events');
        }
    }
);
export const fetchFancy = createAsyncThunk(
    'events/fetchFancy',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await fetchFancyData(eventId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch fancy');
        }
    }
);
export const fetchSportsEventsBeforeLogin = createAsyncThunk(
    'sports/fetchEventsBeforeLogin',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchAllEventsBeforeLogin();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch sports events');
        }
    }
);

export const fetchEventDetails = createAsyncThunk(
    'events/fetchDetails',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await fetchEventDetailsById(eventId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch event details');
        }
    }
);


export const fetchEventDetailsBeforeLogin = createAsyncThunk(
    'events/fetchDetailsBeforeLogin',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await fetchEventDetailsByIdBeforLogin(eventId);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch event details');
        }
    }
);

export const fetchAllEventTypesAsync = createAsyncThunk(
    'events/fetchAllEventTypes',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetchAllEventTypes();
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch event types');
        }
    }
);

export const fetchOpenBetEventsAsync = createAsyncThunk(
    'events/fetchOpenBetEvents',
    async (event_type, { rejectWithValue }) => {
        try {
            const response = await fetchOpenBetEvents(event_type);
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Failed to fetch open bet events');
        }
    }
);

const eventsSlice = createSlice({
    name: 'events',
    initialState: {
        eventTypes: [],
        openBetEvents: [],
        events: [],
        fancy: [],
        cricketEvents: [],
        soccerEvents: [],
        tennisEvents: [],
        cricketLiveEvents: [],
        soccerLiveEvents: [],
        tennisLiveEvents: [],
        eventData: null,
        currentEventId: null,
        loading: false,
        error: null,
        sortedMarketTypes: []
    },
    reducers: {
        clearEvents(state) {
            state.events = [];
            state.eventTypes = [];
            state.fancy = [];
            state.cricketEvents = [];
            state.soccerEvents = [];
            state.tennisEvents = [];
            state.cricketLiveEvents = [];
            state.soccerLiveEvents = [];
            state.tennisLiveEvents = [];
            state.eventData = null;
            state.currentEventId = null;
            state.error = null;
        },
        setCurrentEventId(state, action) {
            state.currentEventId = action.payload;
        },
        setSortedEvents(state, action) {
            state.sortedMarketTypes = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSportsEvents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSportsEvents.fulfilled, (state, action) => {
                state.loading = false;
                state.events = action.payload.data || [];

                state.cricketEvents = state.events.filter(
                    event => event.event_type === 4 || event.event_type === '4'
                );
                state.soccerEvents = state.events.filter(
                    event => event.event_type === 1 || event.event_type === '1'
                );
                state.tennisEvents = state.events.filter(
                    event => event.event_type === 2 || event.event_type === '2'
                );
                state.cricketLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 4
                );
                state.soccerLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 1
                );
                state.tennisLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 2
                );
            })
            .addCase(fetchSportsEvents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch events';
                // state.events = [];
                // state.cricketEvents = [];
                // state.soccerEvents = [];
                // state.tennisEvents = [];
                // state.cricketLiveEvents = [];
                // state.soccerLiveEvents = [];
                // state.tennisLiveEvents = [];
            })
            ///
            .addCase(fetchFancy.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchFancy.fulfilled, (state, action) => {
                state.loading = false;
                state.fancy = action.payload.data || [];
            })
            .addCase(fetchFancy.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch fancy';
                // state.fancy = [];
            })


            .addCase(fetchSportsEventsBeforeLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchSportsEventsBeforeLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.events = action.payload.data || [];

                state.cricketEvents = state.events.filter(
                    event => event.event_type === 4 || event.event_type === '4'
                );
                state.soccerEvents = state.events.filter(
                    event => event.event_type === 1 || event.event_type === '1'
                );
                state.tennisEvents = state.events.filter(
                    event => event.event_type === 2 || event.event_type === '2'
                );
                state.cricketLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 4
                );
                state.soccerLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 1
                );
                state.tennisLiveEvents = state.events.filter(
                    event => event.is_inplay == 'True' && event.event_type == 2
                );
            })
            .addCase(fetchSportsEventsBeforeLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch events';
                // state.events = [];
                // state.cricketEvents = [];
                // state.soccerEvents = [];
                // state.tennisEvents = [];
            })

            .addCase(fetchEventDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.eventData = null;
            })
            .addCase(fetchEventDetails.fulfilled, (state, action) => {
                state.loading = false;
                state.eventData = action.payload.data || action.payload || null;
                state.error = null;
            })
            .addCase(fetchEventDetails.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch event details';
                // state.eventData = null;
            })

            .addCase(fetchEventDetailsBeforeLogin.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.eventData = null;
            })
            .addCase(fetchEventDetailsBeforeLogin.fulfilled, (state, action) => {
                state.loading = false;
                state.eventData = action.payload.data || action.payload || null;
                state.error = null;
            })
            .addCase(fetchEventDetailsBeforeLogin.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch event details';
                // state.eventData = null;
            })
            .addCase(fetchAllEventTypesAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllEventTypesAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.eventTypes = action.payload.data || action.payload || [];
                state.error = null;
            })
            .addCase(fetchAllEventTypesAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch event types';
                // state.eventTypes = [];
            })
            .addCase(fetchOpenBetEventsAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchOpenBetEventsAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.openBetEvents = action.payload.data || action.payload || [];
                state.error = null;
            })
            .addCase(fetchOpenBetEventsAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Failed to fetch open bet events';
                // state.openBetEvents = [];
            });
    }
});

export const { clearEvents, filterEvents, setCurrentEventId, setSortedEvents } = eventsSlice.actions;

export default eventsSlice.reducer;